import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Autocomplete, Box, createTheme, Modal, ThemeProvider } from "@mui/material";
//*files
import cssClasses from "./ReAssignLead.module.css";
import Close from "../../Components/Icons/Close";
//subComponent

import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import CustomInput from "../../Subcomponents/CustomInput";
import Dot from "../../Components/Icons/Dot";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import { Card } from "@mui/material";

import SearchIcon from "../../Assets/Images/Common/SearchIcon.svg";
import Paper from "@mui/material/Paper";
//service

import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { getAllUserActive } from "../../Services/LoginService";
import {
  addLeadLogs,
  addMultipleLeadLogs,
  getUsersForTeamLead,
  reAssignLead,
  reAssignMultipleLeads,
  updateLeadForClaim,
  updateLeadStatus,
  updateMultipleLeadForClaim,
  updateMultipleLeadStatus,
} from "../../Services/Lead";
import { Network } from "@capacitor/network";
import { orderBy } from "lodash";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },

  userName: {
    fontFamily: "Inter-Semibold",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "2rem",
    lineHeight: "3rem",
    color: "#000000",
    marginBottom: "0.5rem",
  },
  userInfo: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    color: "#344054",
    marginBottom: "0.5rem",
  },
}));

export default function ReAssignLead({
  open,
  handleClose,
  modalTitle,
  returnRes,
  data,
  from = "leadcard"
}) {
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [selectedSales, setSelectedSales] = useState("");
  const [allSales, setAllSales] = useState([]);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [helperText, setHelperText] = useState();
  const [disableUpdateBttn, setDisableUpdateBttn] = useState(false);
  const [disabledAutoComplete, setDisabledAutoComplete] = useState(false);

  console.log(data);
  useEffect(() => {
    if (from === "leadcard") {
    if (data?.Sales?.name === "-") {
      setSelectedSales("");
      Network.getStatus().then((status) => {
        if (status.connected) {
            getAllUserActive(null)
            .then((resp) => {
              console.log(resp);
              setAllSales(resp);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          offlineToast();
        }
      });
    } else {
      setSelectedSales(data?.Sales?.name);
      Network.getStatus().then((status) => {
        if (status.connected) {
            getAllUserActive(data?.Sales?.userId)
            .then((resp) => {
              console.log(resp);
             resp = resp.filter((value) => {
                return value.name !== '';
              });
                const sortedArray = orderBy(resp, [(user) => user.name.toLowerCase()],
                  ['asc'])
              setAllSales(sortedArray);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          offlineToast();
        }
      });
      setSelectedUserData({
        userId: data?.Sales?.userId,
        name: data?.Sales?.name,
        email: data?.Sales?.email,
        contactNumber: data?.Sales?.contactNumber,
        title: data?.Sales?.roleId?.title,
      });
      console.log(selectedUserData);
    }
      if (data?.leadstatus?.includes("Cancellation Confirmation Pending ") || data?.leadstatus === 'Unit Change Requested') {
      setDisableUpdateBttn(true);
      setDisabledAutoComplete(true);
        setHelperText(`This lead cannot be ${data?.Sales?.name === "-" ? "assign" : "reassign"} because its status is either 'Cancellation Confirmation Pending' or 'Unit Change Requested'.`)
      } else {
        setDisableUpdateBttn(false);
        setDisabledAutoComplete(false);
      }
    } else {
      setSelectedSales("");
      Network.getStatus().then((status) => {
        if (status.connected) {
          getAllUserActive(null)
            .then((resp) => {
              console.log(resp);
              setAllSales(resp);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          offlineToast();
        }
      });

      const hasCancellationOrUnitChange = data.some(lead =>
        lead?.leadStatus?.includes("Cancellation Confirmation Pending") || lead?.leadStatus === "Unit Change Requested"
      );
      if (hasCancellationOrUnitChange) {
        setDisableUpdateBttn(true);
        setDisabledAutoComplete(true);
        setHelperText(`Can not ${data?.Sales?.name === "-" ? "Assign" : "Reassign"} because some leads status is either 'Cancellation Confirmation Pending' or 'Unit Change Requested'.`)
      } else {
      setDisableUpdateBttn(false);
      setDisabledAutoComplete(false);
    }
    }

  }, []);
useEffect(() => {
console.log({allSales})
}, [allSales])

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem !important",
          fontFamily: "Inter-Medium !important",
          lineHeight: "2.4rem !important",
          borderRadius: 20,
          borderColor: "#84CAFF !important",
          paddingRight: "3rem !important",
          "& input[text]": {
            color: "#101828 !important",
          },
          "& input[input:-internal-autofill-selected]": {
            background: "#F2F4F7 !important",
          },
          "& input[value]": {
            background: "#FFFFF !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused": {
            background: "#FFFFFF",
            border: "1px solid #84CAFF !important",
            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: "1.6rem !important",
          },
        },
      },
    },
  },
});
  async function findTeamLead(userId) {
    return new Promise((resolve, reject) => {
      getUsersForTeamLead(userId).then((userRes) => {
        console.log({ userRes });

        if (userRes[0].parentId !== null) {
          if (userRes[0].isTeamLead) {
            console.log(userRes[0].isTeamLead);

            resolve(userRes[0].userId);
          } else if (!userRes[0].isTeamLead) {
            findTeamLead(userRes[0]?.parentId);
          } else {
            console.log(null);
            resolve(null);
          }
        } else {
          console.log(null);
          resolve(null);
        }
      });
    });
  }
  function save() {
    console.log({selectedUserData})
    if (selectedUserData === null) {
      setHelperText("Please select user to update");
    } else {
      Network.getStatus().then(async (status) => {
        if (status.connected) {
          let teamLeadRes = null;
          // !!Finding Team Lead for dashboard purpose and updating it whenever SM changes
          // !!Commmented this  due to changes come on 18/4/23
          // if (
          //   (selectedUserData?.isTeamLead === false ||
          //     selectedUserData?.isTeamLead === null) &&
          //     selectedUserData?.parentId !== null
          // ) {
          //   teamLeadRes = await findTeamLead(selectedUserData?.parentId?.userId);
          //   console.log({ teamLeadRes });
          // } else if(selectedUserData?.isTeamLead){
          //   teamLeadRes = selectedUserData?.userId;
          // }else{
          //   // !!SuperAdmin
          //   teamLeadRes=null;
          // }

          if (from === "leadcard") {
          reAssignLead(
            data?.leadId,
            selectedUserData.userId,
            selectedUserData?.parentId?.userId
          )
            .then((resp) => {
              console.log(resp);
              closeModal();
              returnRes(true);
              if (data?.Sales?.userId === "-") {
                successTost(`Lead ${data?.leadname} assigned successfully`);
              } else {
                successTost(`Lead ${data?.leadname} Reassigned successfully`);
              }
              //Update status of lead to claimed if user is assigning first time
              // ?? 1/24/23- let it be for now ,ask client for this condition
              if (data?.Sales?.userId === "-") {
                updateLeadForClaim(data?.leadId, selectedUserData?.userId).then(
                  (resp) => {
                    updateLeadStatus(data?.leadId)
                      .then((leadUpdated) => {
                        let obj = {
                          cpId: data.cpid,
                          fosId: data.fosid,
                          userId: loggedInUser.userId,
                          leadId: data.leadId,
                          leadStatus: "Assigned Lead",
                          message: `Lead assigned to ${selectedUserData?.name}(${selectedUserData?.roleId?.title}) by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                        };
                        addLeadLogs(obj)
                          .then((leadLog) => {
                            console.log(leadLog);
                          })
                          .catch((err) => {
                            console.log("leadlog", err);
                          });
                        console.log("leadStatus updated to Claimed");
                      })
                      .catch((err) => {
                        console.log(err.message);
                      })
                      .catch((err) => {
                        console.log(err.message);
                      });
                  }
                );
              } else {
                let obj = {
                  cpId: data.cpid,
                  fosId: data.fosid,
                  userId: loggedInUser.userId,
                  leadId: data.leadId,
                  leadStatus: "Reassigned Lead",
                  message: `Lead reassigned to ${selectedUserData?.name}(${selectedUserData?.roleId?.title}) by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                };
                addLeadLogs(obj)
                  .then((leadLog) => {
                    console.log(leadLog);
                  })
                  .catch((err) => {
                    console.log("leadlog", err);
                  });
              }
            })
            .catch((err) => {
              console.log(err);
            });
          } else {
            console.log("reasssign assign logic here", data);
            const leadIds = data.map(lead => lead.leadId);

            reAssignMultipleLeads(
              leadIds,
              selectedUserData.userId,
              selectedUserData?.parentId?.userId
            )
              .then((resp) => {
                console.log(resp);
                closeModal();
                returnRes(true);
                if (modalTitle === "Assign leads") {
                  successTost(`Leads assigned successfully`);
                } else {
                  successTost(`Leads Reassigned successfully`);
                }
                //Update status of lead to claimed if user is assigning first time
                // ?? 1/24/23- let it be for now ,ask client for this condition
                if (modalTitle === "Assign leads") {
                  updateMultipleLeadForClaim(leadIds, selectedUserData?.userId).then(
                    (resp) => {
                      updateMultipleLeadStatus(leadIds)
                        .then((leadUpdated) => {
                          const leadsArray = data.map(lead => ({
                            cpId: lead.cpId,
                            fosId: lead.fosId,
                            userId: loggedInUser.userId,
                            leadId: lead.leadId,
                            leadStatus: "Assigned Lead",
                            message: `Lead assigned to ${selectedUserData?.name}(${selectedUserData?.roleId?.title}) by ${loggedInUser.name}(${loggedInUser.roleId.title})`
                          }));
                          addMultipleLeadLogs(leadsArray)
                            .then((leadLog) => {
                              console.log(leadLog);
                            })
                            .catch((err) => {
                              console.log("leadlog", err);
                            });
                          console.log("leadStatus updated to Claimed");
                        })
                        .catch((err) => {
                          console.log(err.message);
                        })
                        .catch((err) => {
                          console.log(err.message);
                        });
                    }
                  );
                } else {
                  const leadsArray = data.map(lead => ({
                    cpId: lead.cpId,
                    fosId: lead.fosId,
                    userId: loggedInUser.userId,
                    leadId: lead.leadId,
                    leadStatus: "Reassigned Lead",
                    message: `Lead reassigned to ${selectedUserData?.name}(${selectedUserData?.roleId?.title}) by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                  }));
                  addMultipleLeadLogs(leadsArray)
                    .then((leadLog) => {
                      console.log(leadLog);
                    })
                    .catch((err) => {
                      console.log("leadlog", err);
                    });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          offlineToast();
        }
      });
    }
  }

  function closeModal() {
    handleClose();
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>{modalTitle}</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.wrapperBlock}>
            <div className={cssClasses.blockLabel}>
              Sales Representative :<span style={{ color: "red" }}> *</span>
            </div>
            {/* Auto Complete for searching SM  */}
            <div style={{ position: "relative",width:'60%' }}>
              <ThemeProvider theme={theme }>
                <Autocomplete
                  id="free-solo-2-demo"
                  sx={{
                    fontSize: "1.6rem !important",
                    fontFamily: "Inter-Medium !important",
                    lineHeight: "2.4rem !important",
                    borderColor: "none !important",
                    ".MuiOutlinedInput-root": {
                      background: "#F2F4F7",
                      borderRadius: "8px",
                      "&.Mui-focused": {
                        background: "#FFFFFF",
                        border: "1px solid #84CAFF !important",
                        boxShadow:
                          "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF;",
                      },
                      // "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline ":
                      //   {
                      //     borderColor: "white !important",
                      //   },
                    },
                    "& .MuiSvgIcon-root ": {
                      display: "none !important",
                    },
                  }}
                  disabled={disabledAutoComplete}
                  value={selectedSales}
                  classes={{
                    option: classes.textStyle,
                  }}
                  options={allSales.map((option) => {
                    return { label: option.name, value: option.name };
                  }) }
                  PaperComponent={({ children }) => (
                    <Paper
                      style={{ fontFamily: "Inter-Medium", fontSize: "1.6rem" }}
                    >
                      {children}
                    </Paper>
                  )}
                  onChange={(event, newValue) => {
                    console.log({newValue});
                    if(newValue!==''&&newValue!==null&&newValue!==undefined){
                    setHelperText("");
                    setSelectedSales(newValue?.value);
                    let selectedUserfromArray;
                    selectedUserfromArray = allSales.filter(
                      ({ name }) => newValue.value === name
                    );
                    console.log(selectedUserfromArray[0]);
                    setSelectedUserData(selectedUserfromArray[0]);
                    setDisableUpdateBttn(false);
                    }else{
                      setHelperText('Please select SM');
                      setDisableUpdateBttn(true);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    if(newInputValue!==''||newInputValue!==null){
                      setHelperText("");
                      setSelectedSales(newInputValue);
                      let selectedUserfromArray;
                      selectedUserfromArray = allSales.filter(
                        ({ name }) => newInputValue === name
                      );
                      console.log(selectedUserfromArray[0]);
                      setSelectedUserData(selectedUserfromArray[0]);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      classes={{ root: classes.customTextField }}
                      sx={{
                        fontSize: "1.6rem !important",
                        fontFamily: "Inter-Medium !important",
                        lineHeight: "2.4rem !important",
                        " .MuiFormHelperText-root ": {
                          fontSize: "1.4rem !important",
                          fontFamily: "Inter-Medium",
                          lineHeight: "2rem",
                          marginLeft: "0rem !important",
                        },
                      }}
                      placeholder="Search SM"
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                        style: { fontSize: "3rem" },
                      }}
                      onChange={(e, v) => {
                        console.log(e.target.value);
                      }}
                      helperText={helperText}
                      error={helperText !== ""}
                    />
                  )}
                />
              </ThemeProvider>
              {selectedSales!==''&&(
                <div
                  style={{
                    width: "2rem",
                    position: "absolute",
                    top: "2rem",
                    right: "1rem",
                  }}
                >
                  <img src={SearchIcon} alt={"SearchIcon"} />
                </div>
              )}
            </div>
            {/* <div style={{ width: "50%" }}>
              <DropDown
                list={
                  allSales.map((element, id) => {
                  return {
                    label: element.name,
                    value: element.name,
                  };
                }) ||
                 []}
                selectedValue={selectedSales}
                onChangeSelect={(value) => {
                  setHelperText("");
                  setSelectedSales(value);
                  let selectedUserfromArray;
                  selectedUserfromArray = allSales.filter(
                    ({ name }) => value === name
                  );
                  console.log(selectedUserfromArray[0]);
                  setSelectedUserData(selectedUserfromArray[0]);
                }}
                placeHolder={"Select"}
                style={{
                  background: "#F2F4F7",
                  color: "rgb(102, 112, 133)",
                }}
                helperText={helperText}
              />
            </div> */}
          </div>
          {(selectedUserData !== null&&selectedUserData!==undefined) && (
            <Card className={cssClasses.userCard}>
              <div className={classes.userName}>{selectedUserData?.name}</div>
              <span className={classes.userInfo}>
                {selectedUserData?.roleId?.title}
              </span>
              {selectedUserData?.email&&selectedUserData?.contactNumber&&(
              <div className={classes.userInfo}>
                <span>{selectedUserData?.email}</span> |
                <span>+91{selectedUserData?.contactNumber}</span>
              </div>
              )}
            </Card>
          )}
          {(disableUpdateBttn && disabledAutoComplete &&helperText==='')&&(

          <div className={cssClasses.wrapperBlock}>
            <div className={cssClasses.blockLabel}
                    style={{ width: "100%", textAlign: "left", color: "red",marginTop:'1rem' }}>Cancellation/Change Unit is in Process.You Cannot Update Sales Representative.</div>
          </div>
          )}
        </div>

        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={closeModal}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Update"}
              clicked={() => {
                save();
              }}
              disable={data?.Sales?.userId === selectedUserData?.userId||disableUpdateBttn && disabledAutoComplete}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
